import { actionCreator } from 'utils';
import * as ErrorsTypes from '../types/errorsTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    jobs: null,
    limit: 50,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    calcul: null,
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    filters: {
        formId: '',
        jobId: '',
        customer: '',
        carpetQuality: '',
        size: '',
        machine_ids: undefined,
        expectedEndDate: [],
        status: undefined,
        orderId: '',
        orderItemId: '',
        quantity: '',
        comment: '',
        designId: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ErrorsTypes.LOAD_ERRORS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(ErrorsTypes.LOAD_ERRORS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(ErrorsTypes.LOAD_ERRORS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case ErrorsTypes.SET_ERRORS_FILTERS:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(ErrorsTypes.SET_ERRORS_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case ErrorsTypes.SET_ERRORS_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case ErrorsTypes.SET_ERRORS_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case ErrorsTypes.RESET_ERRORS_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    default:
        return state;
    }
}
